module.exports = __webpack_public_path__ + "img/Resilience_w.2ce1edc6.svg";